import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { FormGroup, FormControl } from '@angular/forms';
import { Params, Router, ActivatedRoute } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { UtilsService } from 'src/app/shared/utils.service';
import { AuthService } from 'src/app/auth/auth.service';
import { DataService } from 'src/app/shared/data.service';
import { AddReferenceComponent } from './add-reference/add-reference.component';
import { User } from 'src/app/auth/user.model';
import { ReferenceDetailsComponent } from './reference-details/reference-details.component';
import { ConfirmDialogComponent } from 'src/app/shared/confirm-dialog/confirm-dialog.component';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';

@Component({
    selector: 'app-product-references',
    templateUrl: './product-references.component.html',
    styleUrls: ['./product-references.component.scss'],
    standalone: false
})
export class ProductReferencesComponent implements OnInit {
  pageEvent!: PageEvent;
  searchForm!: FormGroup;
  showSearch: boolean;
  pageSize = 10;
  pageNumber = 1;
  totalSize = 0;
  userID: number;
  referencesList = new Array<any>();
  queryParams: {
    pageNumber: number;
    pageSize: number;
    searchValue: string | null;
    usedOnMobile: boolean | null;
  } = {
    pageNumber: 0,
    pageSize: 0,
    searchValue: null,
    usedOnMobile: null
  };

  searchValue = "";
  productId: any;
  selected = 'manufacturer';
  usedOnMobile = null;
  user: User;
  productName: any;
  referenceId = null;

  constructor(public dialog: MatDialog, public utils: UtilsService,
              public dataService: DataService,
              private authService: AuthService,
              private route: ActivatedRoute,
              private cdr: ChangeDetectorRef,
              private router: Router) {
    this.showSearch = false;
    this.user = this.authService.getUserData();
    this.userID = this.user.id;
    this.productId = router.routerState.snapshot.root.children[0].children[0].params.id;
    this.productName = router.routerState.snapshot.root.children[0].children[0].params.name;
    this.route.queryParams.subscribe((params: Params) => {
      if (!this.isEmpty(params)) {
        this.referenceId = params.referenceId ? params.referenceId : null;
        this.pageNumber = params.pageNumber ? params.pageNumber : 1;
        this.pageSize = params.pageSize ? params.pageSize : 10;
        this.searchValue =  params.searchValue ? params.searchValue : "";
        this.usedOnMobile = params.usedOnMobile;
        this.selected = params.usedOnMobile === 'true'  ? 'usedOnMobile'  : 'manufacturer';
        if (params.usedOnMobile === undefined) {
          if (this.user.type === this.utils.userTypes.Distributor) {
            this.usedOnMobile = true;
          } else {
            this.usedOnMobile = null;
          }
          this.selected = 'usedOnMobile';
        }
      } else {
        if (this.user.type === this.utils.userTypes.Distributor) {
          this.selected = 'usedOnMobile';
          this.usedOnMobile = true;
        }
      }
      this.getReferences();
      if (this.referenceId) {
        this.openReferenceDetails({id: this.referenceId});
      }
    });
  }

  ngOnInit(): void {
    this.utils.setTitle('Products');
    this.utils.screenTitle.emit({firstTitle: 'Products', firstRoute: '/products',
        secondTitle: this.productName, secondRoute: '/products/product/' + this.productId + '/' + this.productName + '/general',
      });
    this.searchForm = new FormGroup({
      search: new FormControl(this.searchValue),
    });

    if (this.searchValue) {
      this.showSearch = true;
    }
    
    this.searchForm.get('search')?.valueChanges.subscribe(value => {
      const newValue = (value || '').trim();
      if (newValue === '' && this.searchValue !== '') {
        setTimeout(() => this.clearSearch(), 0);
      }
    });
  }

  openReferenceDetails(reference: any) {
    const dialogRef = this.dialog.open(ReferenceDetailsComponent, {disableClose: true, width: '600px', data: {reference}});
  }

  editReference(reference: any) {
    const dialogRef = this.dialog.open(AddReferenceComponent, {
      disableClose: true,
      width: '500px',
      data: {
        type: 'Edit',
        reference
      }
    });
    dialogRef.afterClosed().subscribe((editedReference) => {
      if (editedReference) {
        this.getReferences();
      }
    });
  }

  deleteReference(id: any) {
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      disableClose: true,
      width: '400px',
      data: {
        title: 'Delete',
        page: 'reference',
      }
    });
    dialogRef.afterClosed().subscribe((status) => {
      if (status) {
        if (status === 'accept') {
          this.dataService.delete('product/references/DeleteReference/' + this.productId + '/' + id).then((data) => {
            if (data.statusCode === 200) {
              this.referencesList.forEach( (references, index) => {
                if (references.id === id) {
                  this.referencesList.splice(index, 1);
                  if (this.referencesList.length === 0 && this.pageNumber > 1) {
                    this.pageNumber = this.pageNumber - 1;
                    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
                      searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
                    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
                    '/references'], { queryParams: this.queryParams });
                  } else {
                    this.getReferences();
                  }
                }
              });
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Success',
                  type: 'Success',
                  message: 'Reference deleted successfully',
                  buttonText: 'Ok'
                }
              });
            } else {
              const dialogRef = this.dialog.open(AlertDialogComponent, {
                disableClose: true,
                width: '400px',
                data: {
                  title: 'Error',
                  type: 'Error',
                  message: 'Something went wrong, Please try again!',
                  buttonText: 'Ok'
                }
              });
            }
          });
        }
      }
    });
  }


  filterChange(value: any) {
    this.selected = value;
    if (value === 'manufacturer') {
      this.usedOnMobile = false;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/references'], { queryParams: this.queryParams });    } else if (value === 'usedOnMobile') {
      this.usedOnMobile = true;
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/references'], { queryParams: this.queryParams });    }
  }

  isEmpty(obj: any) {
    return Object.keys(obj).length === 0;
  }

  handlePage(e: any) {
    this.pageNumber = e.pageIndex + 1;
    this.pageSize = e.pageSize;
    this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
      searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
      '/references'], { queryParams: this.queryParams });  }

  handleSearchClick() {
    if (this.showSearch && this.referencesList.length > 0) {
      this.doSearch();
    } else {
      this.showSearch = true;
    }
  }

  doSearch() {
    let searchInput = this.searchForm.get('search')?.value || '';
    this.searchValue = searchInput.trim();
    this.searchForm.get('search')?.setValue(this.searchValue, { emitEvent: false });
    
    if (this.searchValue) {
      this.pageNumber = 1;
      this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
        searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
      this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
        '/references'], { queryParams: this.queryParams });    }
  }

  clearSearch() {
    this.showSearch = !this.showSearch;
    this.searchForm.get('search')?.setValue('');
    this.searchValue = '';
    this.pageNumber = 1;
    this.queryParams = {
      pageNumber: this.pageNumber,
      pageSize: this.pageSize,
      searchValue: this.searchValue,
      usedOnMobile: this.usedOnMobile
    };
    this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
      '/references'], { queryParams: this.queryParams });
  }

  moveToUsedOnMobile(id: any) {
    this.dataService.put('product/references/UpdateUsedOnMobile', {
      referenceId : id,
      productId : parseInt(this.productId.toString(), 10),
      usedOnMobile : true
    }).then((data: any) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile enabled successfully.',
            buttonText: 'Ok'
          }
        });
        this.getReferences();
      }
    });
  }

  moveToNotUsedOnMobile(id: any) {
    this.dataService.put('product/references/UpdateUsedOnMobile', {
      referenceId : id,
      productId : parseInt(this.productId.toString(), 10),
      usedOnMobile : false
    }).then((data: any) => {
      if (data.statusCode === 200) {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Success',
            type: 'Success',
            message: 'Used on mobile disabled successfully',
            buttonText: 'Ok'
          }
        });
        this.getReferences();
      }
    });
  }

  getReferences() {
    if (this.usedOnMobile ===  null) {
      this.dataService.get('product/references/RetrieveReferences/' +
      parseInt(this.productId.toString(), 10) + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue +
      '&AddedBy=2').then((data: any) => {
        if (data.statusCode === 200) {
          this.referencesList = [];
          const referencesData = data.data.records;
          this.totalSize = data.data.count;
          referencesData.forEach((referenceData: any) => {
            // const referenceInstance = new Reference(referenceData);
            this.referencesList.push(referenceData);
          });
          if (referencesData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
              searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
            this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
              '/references'], { queryParams: this.queryParams });          }
        }
      });
    } else {
      let addedBy = this.usedOnMobile === "true" ? '4' : '2';
      if (this.usedOnMobile === true) {
        addedBy = '4';
      }
      this.dataService.get('product/references/RetrieveReferences/' +
      parseInt(this.productId.toString(), 10) + '?pageNumber=' + this.pageNumber +
      '&pageSize=' + this.pageSize +
      '&searchKeyword=' + this.searchValue +
      '&usedOnMobile=' + this.usedOnMobile +
      '&AddedBy=' + addedBy).then((data: any) => {
        if (data.statusCode === 200) {
          this.referencesList = [];
          const referencesData = data.data.records;
          this.totalSize = data.data.count;
          referencesData.forEach((referenceData: any) => {
            // const referenceInstance = new Reference(referenceData);
            this.referencesList.push(referenceData);
          });
          if (referencesData.length === 0 && this.totalSize > 0) {
            this.pageNumber = 1;
            this.queryParams = {pageNumber: this.pageNumber, pageSize: this.pageSize,
              searchValue: this.searchValue, usedOnMobile: this.usedOnMobile};
            this.router.navigate(['/products/product/' + this.productId + '/'   + this.productName +
              '/references'], { queryParams: this.queryParams });          }
        }
      });
    }
  }

  openAddReference() {
    const dialogRef = this.dialog.open(AddReferenceComponent, {disableClose: true, width: '500px', data: {type: 'Add'}});
    dialogRef.afterClosed().subscribe((newReference) => {
      if (newReference) {
        if (this.user.type === this.utils.userTypes.Manufacturer) {
          this.referencesList.unshift(newReference);
          this.totalSize = this.totalSize + 1;
          if (this.referencesList.length <= this.pageSize) {
          } else {
            this.referencesList.splice(this.referencesList.length - 1, 1);
          }
        } else {
          if (this.selected === 'usedOnMobile') {
            this.getReferences();
          }
        }
      }
    });
  }

}
